import axios from 'axios';
import * as url from '../../../helpers/url_helper';
import { del, get, post, put } from '../../../helpers/api_helper';

const postLoginData = data => post(url.POST_API_JWT_LOGIN, data);
const postLogoutData = data => post(url.POST_API_JWT_LOGOUT, data);
const postValidateToken = data => post(url.POST_VALIDATE_TOKEN, data);
export { postLoginData, postLogoutData, postValidateToken };
